import { useState, useEffect } from 'react';

import Head from 'next/head';
import { animateScroll as scroll } from 'react-scroll';
import { Container } from 'reactstrap';

import Collapse from '../../components/includes/collapse';
import Layout from '../../components/layout/layout';
import useI18n from '../../hooks/use-i18n';
import { languages, contentLanguageMap } from '../../language.config';
import getTranslationKeys, { PAGEID } from '../../utils/i18nRosseta';

import '../../styles/faqs.scss';

const RefundPolicy = () => {
  const i18n = useI18n();
  const faqData = Object.values(i18n.t('refund_policy_faq'));
  const refundPage = i18n.t('refund_policy_page');
  const pageMetaData = i18n.t('metadata').refund_policy_page;

  const [isSTT, toggleIsSTT] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', scrollEventListner);
    return () => {
      window.removeEventListener('scroll', scrollEventListner);
    };
  }, []);

  const scrollEventListner = () => {
    toggleIsSTT(window.pageYOffset > 100);
  };

  return (
    <Layout
      page="refundpolicy"
      title={pageMetaData.title}
      description={pageMetaData.description}
      keywords={pageMetaData.keywords}
      analyticData={{ name: 'Refund Policy', properties: { } }}
      pageUrl="refund-policy"
      pageEnabledMarkets={[]}
    >
      <Head />
      <section className="faq-head">
        <Container>
          <div className="faq-wrapper refund-policy-wrapper">
            <div className="head-intro">
              <h1>{refundPage.head_title}</h1>
              <p>{refundPage.head_description}</p>
            </div>
            <div className="sections-wrapper">
              {faqData && faqData.length > 0 && faqData.map((faq, index) => (
                faq.title && faq.title !== 'nil' && (
                <>
                  <div className="faq-section-break" />
                  <section className="faq-section" id={`faq-${index}`}>
                    <h2>{faq.title}</h2>
                    <div className="">
                      {faq.data && faq.data.length > 0 && faq.data.map((row) => (
                        row.question && row.question !== 'nil' && (
                        <div className="faq-collapse-wrapper">
                          <Collapse title={row.question} content={row.answer} />
                        </div>
                        )
                      ))}
                    </div>
                  </section>
                </>
                )
              ))}
            </div>
          </div>
        </Container>
      </section>
      <div
        onClick={() => scroll.scrollToTop()}
        className={`scrollToTop ${isSTT ? 'active' : 'inactive'}`}
        role="presentation"
      >
        <img src="/img/icon_top.svg" alt="top arrow" />
      </div>
    </Layout>
  );
};

export async function getStaticProps({ params }) {
  const lngDict = {};
  const pageId = PAGEID.REFUND_POLICY;
  const keys = getTranslationKeys(pageId);
  const { default: lngDictAll = {} } = await import(
    `../../locales/${contentLanguageMap[params.lng]}.json`
  );
  keys.forEach((data) => {
    lngDict[data] = lngDictAll[data];
  });
  return {
    props: { lng: params.lng, lngDict, pageId }
  };
}

export async function getStaticPaths() {
  return {
    paths: languages.map((l) => ({ params: { lng: l } })),
    fallback: false
  };
}

export default RefundPolicy;
